export default __webpack_public_path__ + "static/media/overwhelmingshout.e529ebff.png";